import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';
import 'tooltipster';

const classes = {
	tooltipTrigger: 'js-m-list-icons__image-tooltip',
	stateTooltipVisible: 'state-m-tooltip--is-visible',
	stateHeaderPos0: 'state-m-navigation--scroll-0-position',
	tooltipCloser: 'js-m-tooltip__closer',
};

@createModule('ListIcons')
/**
 * ListIcons module implementation.
 *
 * @author Lars-Olof Kreim <lars-olof.kreim@namics.com>
 */
export class ListIcons extends TerrificSpec {
	$ctx: JQuery;
	start(resolve: () => void) {
		this.$ctx = $(this._ctx);
		this.initImageTooltip();
		resolve();
	}

	initImageTooltip() {
		const $triggers = this.$ctx.find(`.${classes.tooltipTrigger}`);
		$triggers.on('click', (e: any) => e.preventDefault());
		$triggers.each((i, el) => {
			const $trigger = $(el) as any;
			$trigger.tooltipster({
				theme: 'tooltipster-shadow',
				content: `<div class="m-tooltip__title-wrapper">
					<div class="m-tooltip__title"></div>
					<div class="m-tooltip__title-icon js-m-tooltip__closer"></div>
				</div>
				<div class="m-tooltip__image-wrapper"><img class="m-tooltip__image" src="${$trigger.attr('href')}"/></div>`,
				contentAsHTML: true,
				trigger: 'click',
				interactive: true,
				zIndex: 2,
				functionReady(instance: any) {
					instance._$tooltip.on('click', `.${classes.tooltipCloser}`, (ev: Event) => {
						ev.preventDefault();
						$trigger.trigger('click');
					});
				},
				functionPosition(instance: any, helper: any, position: any) {
					// fine tuning of tooltip position relative to trigger element
					if (position.side === 'top') {
						position.coord.top -= 16;
					} else if (position.side === 'bottom') {
						position.coord.top += 4;
					}
					return position;
				},
			});
		});
	}

	stop() {}
}
